import { CookieService } from '@/app_lib/CookieService';

const OtCookieName = 'OptanonConsent';

export const findOnetrustCookieOptInAds = () => {
  const oneTrust = CookieService.get(OtCookieName);
  return Boolean(oneTrust?.includes('C0004:1') && oneTrust.includes('C0005:1'));
};

export const findOnetrustCookiePerformance = () => {
  const oneTrust = CookieService.get(OtCookieName);
  return Boolean(oneTrust?.includes('C0002:1') && oneTrust.includes('C0003:1'));
};

export const findOnetrustCookieOptIn = () => {
  const oneTrust = CookieService.get(OtCookieName);
  return Boolean(oneTrust?.includes('C0001:1'));
};
